module.exports = __webpack_public_path__ + "static/flowers-9d6363b395414635845ebbd4f04e405e.png";